import styled, { css, FlattenSimpleInterpolation } from "styled-components"
import { assertNever } from "../../../../web-common/src/typings/typeUtils"
import { Breakpoint, breakpointNames, theme } from "../../util/styles/theme"

export type ButtonGroupOrientation = "vertical" | "horizontal"
export type ButtonGroupProps = Partial<
  Record<Breakpoint, ButtonGroupOrientation>
>

const horizontalStyle = (): FlattenSimpleInterpolation => {
  return css`
    flex-direction: row;
  `
}

const verticalStyle = (): FlattenSimpleInterpolation => {
  return css`
    flex-direction: column;
  `
}

const generateMediaQueryValues = (
  breakpointName: Breakpoint,
  orientation?: ButtonGroupOrientation,
): FlattenSimpleInterpolation => {
  switch (orientation) {
    case "horizontal":
      return css`
        ${theme.breakpoints[breakpointName]} {
          ${horizontalStyle()}
        }
      `
    case "vertical":
      return css`
        ${theme.breakpoints[breakpointName]} {
          ${verticalStyle()}
        }
      `
    case undefined:
      // Return undefined to have the last defined breakpoint (or default) to be
      // used in the later breakpoints
      return undefined
    default:
      return assertNever(orientation)
  }
}

export const ButtonGroup = styled.div<ButtonGroupProps>`
  align-items: center;
  display: inline-flex;
  gap: ${theme.spacings.medium};
  // By default horizontal
  ${horizontalStyle()}

  ${props =>
    breakpointNames.map(breakpointName => {
      return generateMediaQueryValues(breakpointName, props[breakpointName])
    })}
`
